import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import WithRender from './performers.tpl.html';
import { RawLocation } from 'vue-router/types/router';

import { loader, content } from '../../config';

import Pagination from 'sensejs/vue/components/pagination';
import { listPerformers } from 'sensejs/performer';
import { getAvatarImage, getParameterByName } from '../../util';
import { Performer, PerformerStatus } from 'sensejs/performer/performer.model';

@WithRender
@Component({
    components: {
        pagination: Pagination
    }
})
export default class Performers extends Vue {

    getAvatarImage = getAvatarImage;
    getParameterByName = getParameterByName;
    loader = loader;
    content = content;

    performers: Performer[] = new Array(40).fill(undefined, 0, 40);

    page: any;
    total: number = 0;
    query: any = {
        limit: 40,
        offset: 0,
        category: '',
        search: ''
    };

    get seoSlugs(){
        const seoCategories = (content.categories) ? content.categories.map((slug: any) => slug.slug) : [];
        return seoCategories;
    }

    @Watch('$route')
    onRouteChange(to: Route | any, from: Route){
        this.query.category = to.params.category ? to.params.category : '';
        this.query.search = to.query.search ? to.query.search : '';
        this.query.offset = to.query.page ? (parseInt(to.query.page) - 1) * this.query.limit : 0;

        this.loadPerformers();
    }

    mounted(){
        const safeMode = this.getParameterByName('safe');
        this.page = (this.seoSlugs.includes(this.$route.params.slug) || safeMode) ? '' : this.$router.push({name: 'Performers'});
        this.query.category = this.$route.params.category ? this.$route.params.category : '';
        this.query.search = this.$route.query.search ? this.$route.query.search : '';
        this.query.offset = this.$route.query.page ? (parseInt(this.$route.query.page as string) - 1) * this.query.limit : 0;

        this.loadPerformers();
    }

    pageChanged(){
        const route: RawLocation = {
            name: this.$route.name,
            query: { page: ((this.query.offset / this.query.limit) + 1).toString() },
            params: { category: this.query.category || '' }
        };

        //Add this to trigger a route change when the user changes the performer limit but the current page doesnt change
        if(this.query.limit !== this.performers.length && route.query){
            route.query.resultsPerPage = this.query.limit.toString();
        }

        if(route.query && this.query.search !== ''){
            route.query.search = this.query.search;
        }

        this.$router.push(route);
    }

    async loadPerformers(){
        const { result, error } = await listPerformers(this.query);

        if(error){
            this.$router.push({ name: 'Performers' });
            throw new Error(`Api${error.message}`);
        }

        if(!result){
            return;
        }

        this.performers = result.performerAccounts;
        this.total = result.total;
    }


}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/pages/performers.ts